export const categories = [
  { id: 'star-gossip', name: '明星八卦', slug: 'star-gossip', icon: 'ri-star-line', description: '明星艺人最新动态、绯闻、恋情、婚变等一手八卦消息' },
  { id: 'wanghong-black', name: '网红翻车', slug: 'wanghong-black', icon: 'ri-car-line', description: '网红主播翻车现场、直播事故、人设崩塌事件全记录' },
  { id: 'dushijubao', name: '独家爆料', slug: 'dushijubao', icon: 'ri-fire-line', description: '独家内幕消息、未公开的猛料、第一手资讯抢先看' },
  { id: 'heiliaotian', name: '黑料实锤', slug: 'heiliaotian', icon: 'ri-hammer-line', description: '有图有真相的黑料实锤，各种不为人知的幕后故事' },
  { id: 'yulebagua', name: '娱乐现场', slug: 'yulebagua', icon: 'ri-live-line', description: '娱乐圈活动现场、综艺录制花絮、颁奖典礼精彩瞬间' },
  { id: 'redianzonghe', name: '热点综合', slug: 'redianzonghe', icon: 'ri-flashlight-line', description: '社会热点与娱乐圈交叉话题，时事吃瓜两不误' },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});